export const POST_PRIVACY_OPTIONS = [
  {
    label: "Public",
    key: 'public',
    icon: '#fa-globe'
  },
  {
    label: "Unlisted",
    key: 'unlisted',
    icon: '#fa-unlock'
  },
  {
    label: "Followers-only",
    key: 'private',
    icon: '#fa-lock'
  },
  {
    label: "Direct",
    key: 'direct',
    icon: '#fa-envelope'
  }
]

export const LONG_POST_LENGTH = 1024
export const LONG_POST_TEXT = "Long post"

export const MAX_STATUS_CHARS = 500
